export enum IDietStoreModelKey {
	DIETS = 'diets',
	MENUS = 'menus',
	MEALS = 'meals',
	MEALPREPS = 'mealpreps',
	SEMI_PRODUCTS = 'semiProducts',
	ALLERGENS = 'allergens',
	MENU_DIET = 'menuDiet',
}

/**
 * Dialog
 */
export enum EDietDialogTabs {
	GENERAL = 'general',
	MACROS = 'macros',
	CALORIES = 'calories',
	PROHIBITES = 'prohibites',
	MARKETING = 'marketing',
	HISTORY = 'history',
}
